module.exports = __webpack_public_path__ + "static/img/good-bg.316f6162.png";